import template from './_agency-link.pug'

// @vue/component
export default {
  template: template(),
  props: {
    agency: {
      type: Object,
      required: true
    }
  },
  computed: {
    agencyLink() {
      return this.agency && this.agency.url
    },
    agencyName() {
      return this.agency && this.agency.name
    }
  }
}
